import { render, staticRenderFns } from "./MPHeader.vue?vue&type=template&id=b0436910"
import script from "./MPHeader.vue?vue&type=script&lang=js"
export * from "./MPHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports